import axios from 'axios';

export const apiService = {
  async enviarFotoAlServidor(data, foto, etiqueta, imgIndex) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value ?? '');
    });
    if (foto) {
      formData.append('imagen', foto, `${etiqueta.replace(' ', '_').toLowerCase()}.png`);
      formData.append('imgIndex', imgIndex);
    }

    const response = await axios.post('https://inspecciones.redas.com.ar/api/v4.php', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  },

  async enviarDatosAlServidor(data, fotos) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value ?? '');
    });

    let imgIndex = 1;
    for (const [etiqueta, foto] of Object.entries(fotos)) {
      if (foto) {
        formData.append('imagen', foto, `${etiqueta.replace(' ', '_').toLowerCase()}.png`);
        formData.append('imgIndex', imgIndex);
        imgIndex++;
      }
    }

    const response = await axios.post('https://inspecciones.redas.com.ar/api/v4.php', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  },
};